/**
 * Christmas icons — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_seasons`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const christmasIconsPack: ToilePack = {
    slug: 'christmas-icons',
    category: 'season',
    name: 'Christmas icons',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 1024, h: 1024},
    readings: [
        {key: 'tree', label: 'Tree icon', subject: 'a christmas tree reduced to one simple glyph with a star on top, built to read small'},
        {key: 'gift', label: 'Gift icon', subject: 'a wrapped gift box with a bow reduced to one simple glyph, built to read small'},
        {key: 'bauble', label: 'Bauble icon', subject: 'a round bauble with a cap and a hook reduced to one simple glyph, built to read small'},
    ],
    styles: [
        {key: 'scandi', label: 'Scandi folk', style: 'scandinavian folk illustration, simplified shapes, no outlines, matte flat colour', palette: 'A limited palette of red, white, forest green and a touch of gold.', framing: 'Centered on a solid cream background, built to read clean at small size.'},
        {key: 'vintage', label: 'Vintage card', style: 'mid-century christmas card illustration, soft halftone grain, slight misregistration', palette: 'Muted red, pine green, cream and a faded gold.', framing: 'Centered on an aged cream paper background with an even margin.'},
        {key: 'cozy', label: 'Cozy cartoon', style: 'cozy cartoon illustration, rounded shapes, thick soft outlines, warm and friendly', palette: 'Warm reds and greens with a glowing amber and snow white.', framing: 'Centered on a solid background with a little room around it.'},
    ],
    directions: ['a stocking instead', 'for a favicon', 'as a filled solid glyph'],
    directionHint: 'try: a stocking instead',
    seo: {
        title: 'Christmas Icons: Tree, Gift, and Bauble Designs',
        metaDescription: 'Nine christmas icons -- tree, gift, and bauble -- in scandi folk, vintage card, and cozy cartoon finishes. Simple glyphs built to read small.',
        h1: 'Christmas icons: tree, gift, and bauble in three styles',
        tagline: 'Nine icons, three December marks, three finishes each.',
        intro: 'Nine small December icons -- a tree, a gift, and a bauble -- each reduced to one clean glyph built to read at 32 pixels. Rendered in scandi folk, vintage card, and cozy cartoon finishes for app icons, favicons, and sticker sheets. Ask for a stocking instead, or a filled solid glyph, and the same three finishes carry it.',
        useCases: [
            'a website favicon',
            'an app icon set',
            'a sticker sheet accent',
            'a holiday email header icon',
        ],
        faq: [
            {q: 'What does this pack actually look like?', a: 'Nine icon renders of three December marks -- a tree, a gift, and a bauble -- each in scandi folk, vintage card, and cozy cartoon finishes, built to read clean at small sizes.'},
            {q: 'Can I get a different icon, like a stocking?', a: 'Yes -- the direction field takes any variation, including a stocking instead, a filled solid glyph, or a favicon crop.'},
            {q: 'What size do these come in?', a: 'Each icon renders at 1024x1024, which scales cleanly down to a 32px favicon or up to a printed sticker.'},
            {q: 'Can I use these commercially?', a: 'Yes -- the icons are yours to use in personal or commercial projects, including client sites and products.'},
        ],
    },
}
